<template>
    <article>
        <section>
            <h3  class="text-center">REPORTE DE VALES</h3>
        </section>
        <!-- {{ $route.params }} -->
        <div class="row justify-content-center mt-5 mb-4">
              <input type="date" v-model="dateInit" name="fechaInicial" class="mt-1 ml-2 form-control col-2">
              <input type="date" v-model="dateEnd" name="fechaFinal" class="mt-1 ml-2 form-control col-2">
              <button class="btn btn-secondary ml-3" @click="getTickets($route.params.client !== undefined ? $route.params.client.key_client : null)">Buscar</button>
        </div>
        <section>
          <b-tabs card>
              <b-tab title="VALES">
                <div class="row justify-content-end mb-4 mt-4">
                  <jsonExcel :data="vales"
                    class="btn btn-secondary"
                    :fields= "{
                      'Folio': 'folio',
                      'Codigo de barras': 'barcode',
                      'Tipo': 'type',
                      'Cliente': 'client',
                      'Total de vale': 'amount',
                      'Total usado': 'amount_used',
                      'Total disponible': 'disponible',
                      'Ultima actualización': 'update_at',
                      'Estatus': 'status'
                    }"
                    worksheet="Reporte de vales"
                    name="Reporte de vales.xls"
                  >
                    Descargar a Excel
                  </jsonExcel>
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="vales"
                  :sort-options="{
                    enabled: true,
                  }"
                  styleClass="vgt-table bordered"
                  :pagination-options="{
                    enabled: true,
                    mode: 'registros',
                    position: 'top',
                    perPage: 15,
                    nextLabel: 'siguiente',
                    prevLabel: 'anterior',
                    rowsPerPageLabel: 'Filas por página',
                    ofLabel: 'de',
                    pageLabel: 'páginas', // for 'pages' mode
                    allLabel: 'Todos',
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'actions'">
                      <button type="button" class="btn btn-secondary" @click="getDetailTicket(props.row)">
                        <font-awesome-icon :icon="['fa', 'eye']"/>
                      </button>
                      &nbsp;
                      <button type="button" class="btn btn-secondary" @click="getDevolutionTicket(props.row)">
                        <font-awesome-icon :icon="['fa', 'print']"/>
                      </button>
                      &nbsp;
                      <button v-if="myRoleId === 1" type="button" class="btn btn-secondary" @click="selectedNote(props.row)">
                        <font-awesome-icon :icon="['fa', 'wrench']"/>
                      </button>
                    </span>
                  </template>
                </vue-good-table>
              </b-tab>
              <b-tab title="DEVOLUCIONES">
                <div class="row justify-content-end mb-4 mt-4">
                <jsonExcel :data="devolutions"
                    class="btn btn-secondary"
                    :fields= "{
                      'Folio': 'folio',
                      'Codigo de barras': 'barcode',
                      'Tipo': 'type',
                      'Cliente': 'client',
                      'Total de vale': 'amount',
                      'Total usado': 'amount_used',
                      'Total disponible': 'disponible',
                      'Ultima actualización': 'update_at',
                      'Estatus': 'status'
                    }"
                    worksheet="Reporte de devoluciones"
                    name="Reporte de devoluciones.xls"
                  >
                    Descargar a Excel
                </jsonExcel>
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="devolutions"
                  :sort-options="{
                    enabled: true,
                  }"
                  styleClass="vgt-table bordered"
                  :pagination-options="{
                    enabled: true,
                    mode: 'registros',
                    position: 'top',
                    perPage: 15,
                    nextLabel: 'siguiente',
                    prevLabel: 'anterior',
                    rowsPerPageLabel: 'Filas por página',
                    ofLabel: 'de',
                    pageLabel: 'páginas', // for 'pages' mode
                    allLabel: 'Todos',
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'actions'">
                      <button type="button" class="btn btn-secondary m-1" @click="getDetailTicket(props.row)">
                        <font-awesome-icon :icon="['fa', 'eye']"/>
                      </button>
                      &nbsp;
                      <button type="button" class="btn btn-secondary m-1" @click="getDevolutionTicket(props.row)">
                        <font-awesome-icon :icon="['fa', 'print']"/>
                      </button>
                      &nbsp;
                      <button v-if="myRoleId === 1" type="button" class="btn btn-secondary m-1" @click="selectedNote(props.row)">
                        <font-awesome-icon :icon="['fa', 'wrench']"/>
                      </button>
                      <button v-if="myRoleId === 1" type="button" class="btn btn-danger m-1" @click="confirmCancelNote(props.row)">
                        <font-awesome-icon :icon="['fa', 'minus-circle']"/>
                      </button>
                    </span>
                  </template>
                </vue-good-table>
              </b-tab>
            </b-tabs>
        </section>
        <modal name="detailTicket" :scrollable="true" height="650" class="">
          <div class="text-right">
            <span class="close-modal" @click="$modal.hide('detailTicket')">
              <font-awesome-icon :icon="['fal', 'sliders-v']" />
            </span>
          </div>
          <div class="reset-pass">
            <h2 class="text-center">Detalle de ticket {{ detail.type }}</h2>
            <div class="container col-11 mt-4">
              <div class="">
                <p><b>FOLIO: <span style="color: blue">{{ detail.folio }}</span></b></p>
                <p><b>CLIENTE:  <span style="color: blue">{{ detail.fullName }}</span></b></p>
                <p><b>FECHA DE EMISIÓN:  <span style="color: blue">{{ detail.create_at }}</span></b></p>
                <p><b>ULTIMA ACTUALIZACIÓN:  <span style="color: blue">{{ detail.update_at }}</span></b></p>
              </div>
            </div>
            <div class="container col-11 mt-4">
              <!-- {{ rows.used }} -->
              <b-table
                striped
                selectable
                class="table-adelantazo"
                select-mode="multi"
                selectedVariant="success"
                responsive="sm"
                show-empty
                stacked="md"
                :items="detail.used"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
              >
              <template v-slot:cell(amount)="row">
                  <div align="center" class="history-amount">
                     <span>$ {{row.item.amount | formatNumberCurrency}}</span>
                  </div>
              </template>
              <template v-slot:cell(action)="row">
                  <div align="center" class="history-amount">
                    <button class="btn" @click="print(row)">
                      <font-awesome-icon :icon="['fa', 'print']"/>
                    </button>
                  </div>
                </template>
              </b-table>
            </div>
            <!-- <div class="text-center">
              <button type="submit" class="btn btn-primary text-center" @click="updateInfo">Actualizar</button>
            </div> -->
          </div>
        </modal>
        <modal name="configNote" :scrollable="true" height="200" class="">
          <div class="text-right">
            <span class="close-modal" @click="$modal.hide('configNote')">
              <font-awesome-icon :icon="['fal', 'sliders-v']" />
            </span>
          </div>
          <div class="reset-pass">
            <h2 class="text-center">Vale seleccionada {{ noteSelected.folio }}</h2>
            <div class="container col-11 mt-4">
              <div class="row justify-content-center">
                <button class="btn m-3" :class="{ 'btn-danger': noteSelected.status === 'ACTIVO', 'btn-success': noteSelected.status !== 'ACTIVO' }" @click="changeStatusNote()">
                      <font-awesome-icon :icon="['fa', 'print']"/>
                      {{ noteSelected.status === 'ACTIVO' ? 'DESHABILITAR' : 'ACTIVAR'}}
                </button>
                <button class="btn btn-info m-3" @click="updateDateNote()">
                      <font-awesome-icon :icon="['fa', 'print']"/>
                      ACTULIZAR FECHA
                </button>
              </div>
            </div>
          </div>
        </modal>
        <ticket :ticket="ticketDeCompra" :enterprise="enterpriseData.name" :print="countPrint" />
        <devolutionTicket :folio="devolutionFolio" :enterprise="enterpriseData.name" :print="countPrintDevolution" :type="devolutionType"/>
    </article>
</template>
<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import { mapGetters } from 'vuex'
import ticket from '../sales/ticket.vue'
import moment from 'moment'
import devolutionTicket from '../sales/devolutionTicket'
import { BTabs, BTab, BTable } from 'bootstrap-vue'
import JsonExcel from 'vue-json-excel'

export default {
  components: {
    BTable,
    ticket,
    devolutionTicket,
    BTabs,
    BTab,
    JsonExcel
  },
  data () {
    return {
      devolutions: [],
      vales: [],
      countPrintDevolution: 0,
      devolutionFolio: 0,
      devolutionType: null,
      enterpriseData: [],
      ticketDeCompra: 0,
      noteSelected: [],
      dateInit: moment().format('YYYY-MM-DD'),
      dateEnd: moment().format('YYYY-MM-DD'),
      countPrint: 0,
      currentPage: 1,
      perPage: 50,
      pageOptions: [50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      rows: [],
      detail: [],
      columns: [
        {
          label: 'Folio',
          field: 'folio',
          type: 'number',
          filterOptions: {
            placeholder: 'Folio de Ticket',
            enabled: true
          },
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Codigo de Barras',
          field: 'barcode',
          filterOptions: {
            placeholder: 'Codigo',
            enabled: true
          },
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Tipo',
          field: 'type',
          filterOptions: {
            placeholder: 'Tipo de vale',
            enabled: true
          },
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Cliente',
          field: 'client',
          filterOptions: {
            placeholder: 'Nombre del cliente',
            enabled: true
          },
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Total del vale',
          field: 'amount',
          filterOptions: {
            placeholder: 'Total del vale',
            enabled: true
          },
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Total Usado',
          field: 'amount_used',
          filterOptions: {
            placeholder: 'Total usado',
            enabled: true
          },
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Total disponible',
          field: 'disponible',
          filterOptions: {
            placeholder: 'Total disponible',
            enabled: true
          },
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Ultima actualización',
          field: 'update_at',
          filterOptions: {
            placeholder: 'Total disponible',
            enabled: false
          },
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Estatus',
          field: 'status',
          filterOptions: {
            placeholder: 'Estatus',
            enabled: false
          },
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Acciones',
          field: 'actions',
          filterOptions: {
            enabled: false
          }
        }
      ],
      fields: [
        { key: 'invoice', label: 'Folio de Venta', sortable: true, sortDirection: 'desc', thClass: 'text-center', tdClass: 'rowTable text-center' }, // cliente
        { key: 'amount', label: 'Monto usado', sortable: true, sortDirection: 'desc', thClass: 'text-center', tdClass: 'rowTable text-center' },
        { key: 'date', label: 'Fecha de aplicacíon', sortable: true, sortDirection: 'desc', thClass: 'text-center', tdClass: 'rowTable text-center' },
        { key: 'action', label: 'Acciones', sortable: false, sortDirection: 'desc', thClass: 'text-center', tdClass: 'rowTable text-center' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    myRoleId () {
      return this.$store.getters.currentRoleId
    }
  },
  methods: {
    confirmCancelNote (row) {
      try {
        this.$dialog.confirm(`
          <div class="row justify-content-center">
            <div class="col-lg-11 text-center">
              <h4 style="color:red"><b>Por favor, confirma que deseas cancelar esta devolucion. <br>Esta acción no se podra deshacer...</b></h4>
            </div>
          </div>
        `)
          .then(async () => {
            this.cancelNote(row)
          })
          .catch((err) => {
            console.log('Presiono cancelar confirmationDialog', err)
          })
      } catch (error) {
        this.showError('No se pudo actualizar el almacen, intentelo mas tarde...')
      }
    },
    async cancelNote (row) {
      console.log('CANCELACION', row)
      const params = {
        enterprise: this.user.enterprise_id,
        invoice: row.folio
      }
      const response = await axiosAdelaService.post('/cancelDevolution', params)
      console.log(response)
      if (response.status === 200) {
        if (response.data.success) {
          this.showSuccess('Vale Cancelado')
          const params = this.$route.params
          // console.log('ALGOAOASSOA', params.client.key_client)
          let clientId = null
          if (params.client !== undefined) {
            clientId = params.client.key_client
          }
          console.log('parametros', clientId)
          await this.getCurrentEnterprise()
          await this.getTickets(clientId)
        } else {
          this.showError(response.data.error)
        }
      }
    },
    async getTickets (clientId) {
      try {
        this.rows = []
        const params = {
          enterprise_id: this.user.enterprise_id,
          client_id: clientId,
          dateInit: this.dateInit,
          dateEnd: this.dateEnd
        }
        const response = await axiosAdelaService.post('/getTickets', params)
        console.log('VALES', response)
        if (response.status === 200) {
          const data = response.data
          this.devolutions = data.devolutions
          this.vales = data.vales
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener los almacenes.')
      }
    },
    async getDetailTicket (item) {
      try {
        this.$modal.show('detailTicket')
        const params = {
          enterprise_id: this.user.enterprise_id,
          folio: item.folio,
          type: item.type
        }
        console.log(params, item)
        const response = await axiosAdelaService.post('/getDetailTicket', params)
        console.log(response)
        if (response.status === 200) {
          this.detail = response.data.rows
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener los almacenes.')
      }
    },
    async getCurrentEnterprise () {
      try {
        const request = {
          data: this.user.enterprise_id
        }
        const orders = await axiosAdelaService.post('/getEnterprisesSelected', request)
        // console.log('getEnterprisesSelected', orders)
        if (orders.status === 200) {
          this.enterpriseData = orders.data.rows[0]
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    getDevolutionTicket (arg) {
      console.log('DEVOLUTIUON', arg)
      this.devolutionFolio = arg.folio
      this.devolutionType = arg.type
      setTimeout(() => {
        this.countPrintDevolution++
      }, 3000)
    },
    print (row) {
      console.log('AQUI LA IMPRESION', row)
      this.ticketDeCompra = row.item.invoice
      this.countPrint++
    },
    selectedNote (row) {
      this.noteSelected = row
      this.$modal.show('configNote')
    },
    async changeStatusNote () {
      try {
        const orders = await axiosAdelaService.post('/disableNote', this.noteSelected)
        // console.log('getEnterprisesSelected', orders)
        if (orders.status === 200) {
          this.noteSelected = []
          this.showSuccess('Estatus actualizado')
          this.$modal.hide('configNote')
          let clientId = null
          const params = this.$route.params
          if (params.client !== undefined) {
            clientId = params.client.key_client
          }
          await this.getTickets(clientId)
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async updateDateNote () {
      try {
        const orders = await axiosAdelaService.post('/updateDateNote', this.noteSelected)
        // console.log('getEnterprisesSelected', orders)
        if (orders.status === 200) {
          this.noteSelected = []
          this.showSuccess('Fecha actualizada...')
          this.$modal.hide('configNote')
          let clientId = null
          const params = this.$route.params
          if (params.client !== undefined) {
            clientId = params.client.key_client
          }
          await this.getTickets(clientId)
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    }
  },
  async mounted () {
    const params = this.$route.params
    // console.log('ALGOAOASSOA', params.client.key_client)
    let clientId = null
    if (params.client !== undefined) {
      clientId = params.client.key_client
    }
    console.log('parametros', clientId)
    await this.getCurrentEnterprise()
    await this.getTickets(clientId)
  }
}
</script>
